module.exports = __webpack_public_path__ + "img/ide-sprite.61fef10f.svg";